
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Fonction pour mettre à jour l'état mobile
    const updateMobileState = () => {
      const width = window.innerWidth
      const height = window.innerHeight
      const isMobileScreen = width < MOBILE_BREAKPOINT
      const isMobileRatio = width / height < 1.2 // Ratio typique mobile
      
      setIsMobile(isMobileScreen || isMobileRatio)
    }
    
    // Débounce pour éviter les calculs excessifs
    let timeoutId: ReturnType<typeof setTimeout> | undefined
    const debouncedUpdate = () => {
      if (timeoutId) clearTimeout(timeoutId)
      timeoutId = setTimeout(updateMobileState, 100)
    }
    
    // Pour la première exécution
    updateMobileState()
    
    // Écouter les changements de taille d'écran
    window.addEventListener("resize", debouncedUpdate)
    
    // Écouter les changements d'orientation sur mobile
    const orientationHandler = () => {
      // Délai plus long pour l'orientation car le navigateur met du temps à recalculer
      setTimeout(updateMobileState, 200)
    }
    window.addEventListener("orientationchange", orientationHandler)
    
    // Détection de l'événement de changement de mode plein écran
    document.addEventListener("fullscreenchange", updateMobileState)
    
    // Nettoyage
    return () => {
      if (timeoutId) clearTimeout(timeoutId)
      window.removeEventListener("resize", debouncedUpdate)
      window.removeEventListener("orientationchange", orientationHandler)
      document.removeEventListener("fullscreenchange", updateMobileState)
    }
  }, [])

  return isMobile === undefined ? false : isMobile
}
